import React from 'react';

const renderTitle = (title) => <span>{title}</span>;

const renderItem = (id, title) => ({
  key: `${id}`,
  value: title,
  label: (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {title}
    </div>
  ),
});

const renderText = (node, ctx, globalScale) => {
  const label = node.id;
  const fontSize = (12 / globalScale) * (Math.log(node.val) + 1);
  ctx.font = `${fontSize}px Sans-Serif`;
  const textWidth = ctx.measureText(label).width;
  const bckgDimensions = [textWidth, fontSize].map((n) => n + fontSize * 0.2); // some padding

  ctx.fillStyle = 'rgba(0,0,0,0)';
  ctx.fillRect(node.x - bckgDimensions[0] / 2, node.y - bckgDimensions[1] / 2, ...bckgDimensions);

  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'black';
  ctx.fillText(label, node.x, node.y);
};

const renderOptions = (data) => {
  return data.map(({ id, title }) => renderItem(id, title));
};

export { renderTitle, renderItem, renderText, renderOptions };
